<script>
import { onMount } from 'svelte';
import * as Common from './Common.js'
import Router from './pt-router/Router.svelte'
import Front from './routes/Front.svelte'
import Moderation from './routes/Moderation.svelte'
import NotFound from './routes/NotFound.svelte'
import UserView from './UserView.svelte'
import Modal from 'svelte-simple-modal';
import Tools from './routes/Tools.svelte';

const routes = {
	//'/tools/:view': Tools,
	'/moderation': Moderation,
	'/moderation/:id': Moderation,
	'/:page/:id/': Front,
	'/:page/': Front,
	'/': Front,
	'*': NotFound
}

onMount(async () => {
	//Common.updateLoggedInUser()
});

</script>

<body>
	<Modal>
		<Router {routes}/>
	</Modal>
</body>
